module.exports = __webpack_public_path__ + "static/media/abdul.4d6ac886.jpg";